// extracted by mini-css-extract-plugin
module.exports = {"root":"AmountDot_root__HXRV1","amount":"AmountDot_amount__3fkn1"};